import { createCloudReadDeadline } from "../sync/cloud-read-deadline.mjs";

const authBootReadDeadline = createCloudReadDeadline();

/**
 * Restore cached credentials, opportunistically refresh `/me`, and always
 * release the application boot gate. Identity refresh is useful but optional:
 * a stalled or unavailable read must not prevent account cloud sync from
 * mounting and running its own bounded retry policy.
 */
export async function runAuthBootSequence({
  restoreSession,
  isSignedIn,
  refreshIdentity,
  onReady,
  deadline = authBootReadDeadline,
}) {
  try {
    await restoreSession();
    if (isSignedIn()) {
      try {
        await deadline.run((signal) => refreshIdentity(signal));
      } catch {
        /* Cloud sync rechecks account identity on its bounded retry cadence. */
      }
    }
  } catch {
    /* A local restore failure must not leave the application boot gate pinned. */
  } finally {
    onReady();
  }
}
